export const enum PPRouteNames {
  Root = '/',
  Auth = 'auth',
}

export const enum PPPageTypes {
  PlayerPortalsPage = 'player_portals_page',
  PlayerPortalsGridPage = 'player_portals_grid_page',
}

export const PPDefaultChampionship = 'player_portal___the_open'; // used temporarily until we have the user context
